import React, { useState,useEffect } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Button, Tooltip } from 'antd';
import { getList } from '../Utils/FormCalls';
import { DRIFT } from '../../../commons/api';
import { FormOutlined } from '@ant-design/icons';
import { encode as base64_encode } from 'base-64';
import StyledTable from '../../../commons/styles/table';
import themeSettings from '../../../commons/styles/themeSettings.json';
const APIList = {
  getList: `${DRIFT.GET}`
};
const DriftCalculationWorkbench = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    const fetchData = async () => {
      const response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? response : []);
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);
  const translation = (keyword) => {
    return translationCache[keyword] || keyword;
  };
    const columns = [
      {
        title: translation('Reference From Date'),
        dataIndex: 'RefFromDate',
        key: 'RefFromDate',
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: translation('Reference To Date'),
        dataIndex: 'RefToDate',
        key: 'RefToDate',
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: translation('Current From Date'),
        dataIndex: 'CurrentFromDate',
        key: 'CurrentFromDate',
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: translation('Current To Date'),
        dataIndex: 'CurrentToDate',
        key: 'CurrentToDate',
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: translation('Calculation Date'),
        dataIndex: 'CreatedTime',
        key: 'CreatedTime',
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: translation('Calculation By'),
        dataIndex: 'CreatedName',
        key: 'CreatedName'
      },
      {
        title: translation('Model Name'),
        dataIndex: 'ModelName',
        key: 'ModelName'
      },
      {
        title: translation('Description'),
        dataIndex: 'Name',
        key: 'Name'
      },
      {
        title: translation('Type'),
        dataIndex: 'Type',
        key: 'Type'
      },
      {
        title: translation('Action'),
        render: (text, record) => (
          <>
            <Tooltip
              title={
                record.model_1_Status === 'Completed' && record.model_2_Status === 'Completed'
                  ? translation('Click to Compare')
                  : translation('Open Details')
              }
            >
              <a
                // style={{ marginRight: "5px" }}
                onClick={() =>
                  props.navigate(`/rubus/RbsAnalytics/MonitorDrift/${base64_encode(record.Id)}`)
                }
              >
                <FormOutlined />
              </a>
            </Tooltip>
          </>
        )
      }
    ];
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Tooltip title={translation('Click here to register a new model')}>
            <Button
              onClick={() => props.navigate('/rubus/RbsAnalytics/MonitorDrift')}
              type="primary"
              style={{
                marginBottom: 8
              }}
              
            >
              {translation('New')}
            </Button>
          </Tooltip>
        </div>
        <StyledTable size="small"
          data-testid="workbenchList"
          theme={themeSettings}
          dataSource={Array.isArray(dataSource) ? dataSource.map((data, index) => ({ ...data, key: index })) : []}
          columns={columns}
        ></StyledTable>
      </>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(DriftCalculationWorkbench);
